import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, Signal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-loading-small',
  imports: [FontAwesomeModule],
  template: `
    <div @fadeInOut class="flex justify-center items-center">
      <fa-icon [icon]="spinnerIcon" class="animate-spin text-primary text-2xl"></fa-icon>
    </div>
  `,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0px)' })),
        animate('100ms ease-in', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [animate('300ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class LoadingSmallComponent {
  spinnerIcon = faSpinner;
}
